module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isAdmin ? 'admin' : '',
    attrs: {
      "id": "chatMessageContainer"
    }
  }, [_c('chatMessage'), _vm._v(" "), (_vm.isAdmin) ? _c('chatAdminInputArea') : _vm._e(), _vm._v(" "), _c('chatInputArea'), _vm._v(" "), _c('contextMenu'), _vm._v(" "), _c('chatMessageSetting'), _vm._v(" "), _c('chatMessageCheerSetting'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "popupLayout"
    }
  }, [_c('div', {
    attrs: {
      "id": "popupLayoutInner"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f42745c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-message-container.vue
// module id = 98
// module chunks = 0